var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("c-select", {
        attrs: {
          type: "select",
          "floating-label": _vm.field.name,
          "required-mark": _vm.field.required,
          searchable: _vm.searchable,
          items: _vm.options,
          multiple: true,
          "custom-options": _vm.field.custom,
          invalid: !!_vm.error,
          error: _vm.error,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }